<template>
<div class="modal__mask" :id="id" v-show="isOpen">
	<div class="modal__wrapper">
		<div class="modal" v-bind:class="size">
			<button v-if="showCloseButton" type="button" class="btn-cta modal__close" @click="toggleModal"><svg viewBox="0 0 65 65"><use xlink:href="#close"></use></svg></button>
			<slot name="content"></slot>
		</div>
	</div>
</div>
</template>

<script>
export default {
	props: {
		id: String,
		opened: Boolean,
		size: {
			type: String,
			default: "modal--normal"
		},
		showCloseButton: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			isOpen: this.opened
		}
	},
	methods: {
		toggleModal() {
			this.isOpen = !this.isOpen
		},
	}
}
</script>

<style lang="scss">
  .modal {
    max-height: 100vh;
    max-width: 720px;
    overflow-y: auto;

		@media (max-width: 992px){
			width: 100%;
			margin: 30px;
		}

    &__mask {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .5);
        z-index: 900;
    }

    &__wrapper {
      position: fixed;
      height: 100vh;
      width: 100vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &--full {
        min-width: auto;
        width: 100%;
        max-width: 1500px;
    }

    &--mini {
        min-width: 300px;
    }

    &__close {
        margin-top: 12px;
        margin-right: 12px;
    }

}
</style>
